import SpaceCreate from "./SpaceCreate"
function GetStarted(){
    return (<div>
        <SpaceCreate title='project' subtitle='ManagementMethod'/>
    </div>)
}

export default GetStarted;